<template>
  <DrawerContainer
    ref="drawerContainer"
    :dialogShow="dialogShow"
    v-if="dialogShow"
    :dialog-width="'40%'"
    title="客服代下单"
    @resetPopupData="dialogShow = false"
    @submitPopupData="submitForm"
  >
    <div class="order-box custom-form">
      <el-form ref="form" :model="form" :rules="rules" label-position="top">
        <div class="right-title">
          <el-image :src="cheImage" class="title-label"></el-image>货主信息
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="货主姓名" prop="ownerName">
              <el-input
                v-model="form.ownerName"
                clearable
                autocomplete="off"
                maxlength="30"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号码" prop="ownerPhone">
              <el-input
                v-model="form.ownerPhone"
                clearable
                autocomplete="off"
                maxlength="11"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="right-title">
          <el-image :src="cheImage" class="title-label"></el-image>货物信息
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="货物名称" prop="cargo.cargoName">
              <el-input
                v-model="form.cargo.cargoName"
                clearable
                autocomplete="off"
                maxlength="30"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="包装方式" prop="cargo.packingWays">
              <el-input
                v-model="form.cargo.packingWays"
                clearable
                autocomplete="off"
                maxlength="30"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24" class="custom-form-label">
            <el-form-item
              label="货物体积/重量"
              prop="cargo.byPiece"
              label-position="left"
            >
              <el-switch v-model="form.cargo.byPiece" active-color="#13ce66">
              </el-switch>
              <span class="unit">件装</span>
            </el-form-item>
          </el-col>
          <template v-if="form.cargo.byPiece">
            <el-col :span="12" class="custom-form-input">
              <div class="custom-label">单件体积（单位 米）</div>
              <div class="custom-input-box">
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item prop="cargo.cargoLength">
                      <el-input
                        v-model="form.cargo.cargoLength"
                        clearable
                        autocomplete="off"
                        maxlength="30"
                        placeholder="请输入"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item prop="cargo.cargoWidth">
                      <el-input
                        v-model="form.cargo.cargoWidth"
                        clearable
                        autocomplete="off"
                        maxlength="30"
                        placeholder="请输入"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item prop="cargo.cargoHeight">
                      <el-input
                        v-model="form.cargo.cargoHeight"
                        clearable
                        autocomplete="off"
                        maxlength="30"
                        placeholder="请输入"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="12" class="custom-form-input">
              <div class="custom-label">件数</div>
              <el-form-item prop="cargo.piece">
                <el-input
                  v-model="form.cargo.piece"
                  clearable
                  style="width: 100%"
                  autocomplete="off"
                  maxlength="30"
                  placeholder="请输入"
                >
                  <span slot="suffix">件</span>
                </el-input>
              </el-form-item>
            </el-col>
          </template>
          <template v-else>
            <el-col :span="12" class="custom-form-input">
              <div class="custom-label">货物体积（单位 米）</div>
              <div class="custom-input-box">
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item prop="cargo.cargoLength">
                      <el-input
                        v-model="form.cargo.cargoLength"
                        clearable
                        autocomplete="off"
                        maxlength="30"
                        placeholder="请输入"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item prop="cargo.cargoWidth">
                      <el-input
                        v-model="form.cargo.cargoWidth"
                        clearable
                        autocomplete="off"
                        maxlength="30"
                        placeholder="请输入"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item prop="cargo.cargoHeight">
                      <el-input
                        v-model="form.cargo.cargoHeight"
                        clearable
                        autocomplete="off"
                        maxlength="30"
                        placeholder="请输入"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="12" class="custom-form-input">
              <div class="custom-label">
                <div>货物重量</div>
                <div class="label">
                  <el-radio-group v-model="form.cargo.wightUnit">
                    <el-radio :label="1">吨</el-radio>
                    <el-radio :label="2">公斤</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <el-form-item prop="cargo.weight">
                <el-input
                  v-model="form.cargo.weight"
                  clearable
                  style="width: 100%"
                  autocomplete="off"
                  maxlength="30"
                  placeholder="请输入"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </template>
        </el-row>
        <div class="right-title">
          <el-image :src="cheImage" class="title-label"></el-image>运输路线
        </div>
        <div class="line-box">
          <div class="line-box-list" v-for="(item, index) in form.dress">
            <div class="line-list-left">
              <div class="line-left-top">
                <div class="line-left-top-img-box">
                  <el-image
                    :src="zhuangImage"
                    class="line-left-top-left"
                  ></el-image>
                </div>
                <div class="line-left-top-right">
                  <div class="city-box">
                    <el-form-item
                      :prop="'dress.' + index + '.location'"
                      :rules="rules.location"
                    >
                      <el-cascader
                        style="width: 100%"
                        :ref="'cascader-dress' + index"
                        v-model="item.location"
                        :props="city3Props"
                        placeholder="请选择省/市/区(县)"
                        @change="
                          handleChange(
                            $event,
                            'dress',
                            index,
                            'cascader-dress' + index
                          )
                        "
                      ></el-cascader>
                    </el-form-item>
                  </div>
                  <div class="address-box">
                    <el-form-item
                      :prop="'dress.' + index + '.address'"
                      :rules="rules.address"
                    >
                      <el-input
                        v-model="item.address"
                        clearable
                        autocomplete="off"
                        maxlength="300"
                        placeholder="请输入详细地址"
                      />
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="line-left-bottom">
                <div class="line-left-bottom-list">
                  <div class="left-txt">联系人：</div>
                  <div class="right-input">
                    <el-form-item
                      :prop="'dress.' + index + '.linkUsername'"
                      :rules="rules.linkUsername"
                      style="width: 100%"
                    >
                      <el-input
                        v-model="item.linkUsername"
                        clearable
                        style="width: 100%"
                        autocomplete="off"
                        maxlength="30"
                        placeholder="请输入联系人姓名"
                      >
                      </el-input>
                    </el-form-item>
                    <el-form-item
                      :prop="'dress.' + index + '.linkPhone'"
                      :rules="rules.linkPhone"
                      style="margin-left: 0.1rem; width: 100%"
                    >
                      <el-input
                        v-model="item.linkPhone"
                        clearable
                        style="width: 100%"
                        autocomplete="off"
                        maxlength="11"
                        placeholder="请输入联系人电话"
                      >
                      </el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="line-left-bottom-list">
                  <div class="left-txt">装货时间：</div>
                  <div class="right-input">
                    <el-form-item
                      :prop="'dress.' + index + '.startTime'"
                      :rules="rules.startTime"
                      style="width: 100%"
                    >
                      <el-date-picker
                        style="width: 100%"
                        v-model="item.startTime"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm"
                        format="yyyy-MM-dd HH:mm"
                        placeholder="请选择开始时间"
                      ></el-date-picker>
                    </el-form-item>
                    <el-form-item
                      :prop="'dress.' + index + '.endTime'"
                      :rules="rules.endTime"
                      style="width: 100%; margin-left: 0.1rem"
                    >
                      <el-date-picker
                        style="width: 100%"
                        v-model="item.endTime"
                        type="datetime"
                        value-format="yyyy:MM:dd HH:mm"
                        format="yyyy-MM-dd HH:mm"
                        placeholder="请选择结束时间"
                      ></el-date-picker>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </div>
            <template v-if="index === 0">
              <div class="line-list-right">
                <el-image
                  :src="jiaImage"
                  class="jia-img"
                  @click="add('dress', item, index)"
                ></el-image>
                <div class="jia-txt" @click="add('dress', item, index)">
                  加装货地
                </div>
              </div>
            </template>
            <template v-if="index > 0">
              <div class="line-list-right">
                <el-image
                  :src="jianImage"
                  class="jia-img"
                  @click="del('dress', item, index)"
                ></el-image>
                <div class="jia-txt" @click="del('dress', item, index)">
                  删除
                </div>
              </div>
            </template>
          </div>
          <div class="line-box-list" v-for="(item, index) in form.unload">
            <div class="line-list-left">
              <div class="line-left-top">
                <div class="line-left-top-img-box">
                  <el-image
                    :src="xieImage"
                    class="line-left-top-left"
                  ></el-image>
                </div>
                <div class="line-left-top-right">
                  <div class="city-box">
                    <el-form-item
                      :prop="'unload.' + index + '.location'"
                      :rules="rules.location"
                    >
                      <el-cascader
                        style="width: 100%"
                        :ref="'cascader-unload' + index"
                        v-model="item.location"
                        :props="city3Props"
                        placeholder="请选择省/市/区(县)"
                        @change="
                          handleChange(
                            $event,
                            'unload',
                            index,
                            'cascader-unload' + index
                          )
                        "
                      ></el-cascader>
                    </el-form-item>
                  </div>
                  <div class="address-box">
                    <el-form-item
                      :prop="'unload.' + index + '.address'"
                      :rules="rules.address"
                    >
                      <el-input
                        v-model="item.address"
                        clearable
                        autocomplete="off"
                        maxlength="300"
                        placeholder="请输入详细地址"
                      />
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="line-left-bottom">
                <div class="line-left-bottom-list">
                  <div class="left-txt">联系人：</div>
                  <div class="right-input">
                    <el-form-item
                      :prop="'unload.' + index + '.linkUsername'"
                      :rules="rules.linkUsername"
                      style="width: 100%"
                    >
                      <el-input
                        v-model="item.linkUsername"
                        clearable
                        style="width: 100%"
                        autocomplete="off"
                        maxlength="30"
                        placeholder="请输入联系人姓名"
                      >
                      </el-input>
                    </el-form-item>
                    <el-form-item
                      :prop="'unload.' + index + '.linkPhone'"
                      :rules="rules.linkPhone"
                      style="margin-left: 0.1rem; width: 100%"
                    >
                      <el-input
                        v-model="item.linkPhone"
                        clearable
                        style="width: 100%"
                        autocomplete="off"
                        maxlength="11"
                        placeholder="请输入联系人电话"
                      >
                      </el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="line-left-bottom-list">
                  <div class="left-txt">装货时间：</div>
                  <div class="right-input">
                    <el-form-item
                      :prop="'unload.' + index + '.startTime'"
                      :rules="rules.startTime"
                      style="width: 100%"
                    >
                      <el-date-picker
                        style="width: 100%"
                        v-model="item.startTime"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm"
                        format="yyyy-MM-dd HH:mm"
                        placeholder="请选择开始时间"
                      ></el-date-picker>
                    </el-form-item>
                    <el-form-item
                      :prop="'unload.' + index + '.endTime'"
                      :rules="rules.endTime"
                      style="width: 100%; margin-left: 0.1rem"
                    >
                      <el-date-picker
                        style="width: 100%"
                        v-model="item.endTime"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm"
                        format="yyyy-MM-dd HH:mm"
                        placeholder="请选择结束时间"
                      ></el-date-picker>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </div>
            <template v-if="index === 0">
              <div class="line-list-right">
                <el-image
                  :src="jiaImage"
                  class="jia-img"
                  @click="add('unload', item, index)"
                ></el-image>
                <div class="jia-txt" @click="add('unload', item, index)">
                  加卸货地
                </div>
              </div>
            </template>
            <template v-if="index > 0">
              <div class="line-list-right">
                <el-image
                  :src="jianImage"
                  class="jia-img"
                  @click="del('unload', item, index)"
                ></el-image>
                <div class="jia-txt" @click="del('unload', item, index)">
                  删除
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="right-title">
          <el-image :src="cheImage" class="title-label"></el-image>用车要求
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="整拼方式" prop="vehicle.vehicleUseType">
              <el-select
                style="width: 100%"
                v-model="form.vehicle.vehicleUseType"
                filterable
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in getConfig('vehicle_use_type')"
                  :key="item.dictLabel"
                  :label="item.dictLabel"
                  :value="item.dictLabel"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车型" prop="vehicleMode">
              <el-select
                style="width: 100%"
                v-model="form.vehicle.vehicleMode"
                filterable
                clearable
                multiple
                collapse-tags
                placeholder="请选择（多选）"
              >
                <el-option
                  v-for="item in getConfig('vehicle_mode')"
                  :key="item.dictLabel"
                  :label="item.dictLabel"
                  :value="item.dictLabel"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车长" prop="vehicleLength">
              <el-select
                style="width: 100%"
                v-model="form.vehicle.vehicleLength"
                filterable
                multiple
                collapse-tags
                clearable
                placeholder="请选择（多选）"
              >
                <el-option
                  v-for="item in getConfig('vehicle_length')"
                  :key="item.dictLabel"
                  :label="item.dictLabel"
                  :value="item.dictLabel"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="right-title">
          <el-image :src="cheImage" class="title-label"></el-image>运单信息要求
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发票要求" prop="needInvoice">
              <el-select
                style="width: 100%"
                v-model="form.needInvoice"
                clearable
                placeholder="请选择"
              >
                <el-option label="是" :value="true"> </el-option>
                <el-option label="否" :value="false"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="回单要求" prop="receiptType">
              <el-select
                style="width: 100%"
                v-model="form.receiptType"
                filterable
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in $dict.receiptTypeOptions"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                v-model="form.remark"
                clearable
                autocomplete="off"
                rows="3"
                type="textarea"
                show-word-limit
                maxlength="50"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </DrawerContainer>
</template>

<script>
import DrawerContainer from "@/components/Drawer.vue";
import CustomCarNumber from "@/components/CustomCarNumber.vue";
import { validatePhone } from "@/utils/validate";
import { getAreaNext, getCheDuiZhang, getDispatchers } from "@/views/commonApi";
import { getConfig } from "@/utils/localDict";
import uploadFiles4 from "@/components/UploadFiles4.vue";
import UploadFiles1 from "@/components/UploadFiles1.vue";
import { orderFreight } from "./api";
export default {
  name: "AddOrEdit",
  components: {
    UploadFiles1,
    DrawerContainer,
    uploadFiles4,
    CustomCarNumber,
  },
  data() {
    return {
      dialogShow: false,
      cheImage: require("@/assets/imgs/title.png"),
      jiaImage: require("@/assets/imgs/jia.png"),
      jianImage: require("@/assets/imgs/jian.png"),
      zhuangImage: require("@/assets/imgs/zhuang.png"),
      xieImage: require("@/assets/imgs/xie.png"),
      city3Props: {
        lazy: true,
        checkStrictly: true, //可选择任意节点
        lazyLoad(node, resolve) {
          // setTimeout(() => {
          const nodes = [];
          let query = {};
          // 构造查询条件
          if (node.value) {
            query = {
              code: node.value,
            };
          }
          //查询接口
          getAreaNext(query).then((res) => {
            res.data.map((item) => {
              let obj = {
                value: item.areaCode,
                label: item.areaName,
                leaf: item.areaLevel === 2,
                disabled: item.areaLevel <= 1,
              };
              nodes.push(obj);
            });
            //重新加载节点
            resolve(nodes);
          });
          // }, 500);
        },
      },
      // form: {
      //   dress: [
      //     {
      //       location: [],
      //       address: "",
      //       addressBookId: "",
      //       cityCode: "",
      //       cityName: "",
      //       districtCode: "",
      //       districtName: "",
      //       endTime: "",
      //       linkPhone: "",
      //       linkUsername: "",
      //       loadType: 1,
      //       provinceCode: "",
      //       provinceName: "",
      //       startTime: "",
      //       tags: "",
      //     },
      //   ],
      //   unload: [
      //     {
      //       location: [],
      //       address: "",
      //       addressBookId: "",
      //       cityCode: "",
      //       cityName: "",
      //       districtCode: "",
      //       districtName: "",
      //       endTime: "",
      //       linkPhone: "",
      //       linkUsername: "",
      //       loadType: 2,
      //       provinceCode: "",
      //       provinceName: "",
      //       startTime: "",
      //       tags: "",
      //     },
      //   ],
      //   cargo: {
      //     byPiece: false,
      //     cargoHeight: "",
      //     cargoLength: "",
      //     cargoName: "",
      //     cargoWidth: "",
      //     // maxWeight: "",
      //     // minWeight: "",
      //     weight: "",
      //     packingWays: "",
      //     pictures: [],
      //     piece: "",
      //     wightUnit: 1,
      //   },
      //   needInvoice: true,
      //   orderId: "",
      //   ownerName: "",
      //   ownerPhone: "",
      //   pointList: [],
      //   receiptType: "",
      //   remark: "",
      //   vehicle: {
      //     vehicleLength: [],
      //     vehicleMode: [],
      //     vehicleUseType: "",
      //   },
      // },
      form: {
        dress: [
          {
            location: ["12", "1201", "120101"],
            address: "的尴尬嘎嘎大发给",
            addressBookId: "",
            cityCode: "1201",
            cityName: "天津",
            districtCode: "120101",
            districtName: "和平",
            endTime: "2025:04:28 20:00",
            linkPhone: "15928585002",
            linkUsername: "卢亮",
            loadType: 1,
            provinceCode: "12",
            provinceName: "天津",
            startTime: "2025-04-28 00:00",
            tags: "",
          },
          {
            location: ["12", "1201", "120102"],
            address: "分公司电饭锅森岛帆高",
            addressBookId: "",
            cityCode: "1201",
            cityName: "天津",
            districtCode: "120102",
            districtName: "河东",
            endTime: "2025:04:28 23:00",
            linkPhone: "15928585003",
            linkUsername: "卢亮一号",
            loadType: 1,
            provinceCode: "12",
            provinceName: "天津",
            startTime: "2025-04-28 13:00",
            tags: "",
          },
        ],
        unload: [
          {
            location: ["13", "1302", "130203"],
            address: "分公司大地飞歌森岛帆高送达方刚",
            addressBookId: "",
            cityCode: "1302",
            cityName: "唐山",
            districtCode: "130203",
            districtName: "路北",
            endTime: "2025-04-30 07:00",
            linkPhone: "15928585001",
            linkUsername: "阿鸡",
            loadType: 2,
            provinceCode: "13",
            provinceName: "河北",
            startTime: "2025-04-30 00:00",
            tags: "",
          },
          {
            location: ["13", "1302", "130202"],
            address: "发过的发生讽德诵功森岛帆高水电费刚",
            addressBookId: "",
            cityCode: "1302",
            cityName: "唐山",
            districtCode: "130202",
            districtName: "路南",
            endTime: "2025-04-30 22:00",
            linkPhone: "15928585007",
            linkUsername: "阿吉一号",
            loadType: 2,
            provinceCode: "13",
            provinceName: "河北",
            startTime: "2025-04-30 07:00",
            tags: "",
          },
        ],
        cargo: {
          byPiece: true,
          cargoHeight: "3",
          cargoLength: "1",
          cargoName: "一车大便",
          cargoWidth: "12",
          weight: "",
          packingWays: "桶装",
          pictures: [],
          piece: "44",
          wightUnit: 1,
        },
        needInvoice: true,
        orderId: "",
        ownerName: "王超",
        ownerPhone: "15928585007",
        pointList: [
          {
            location: ["12", "1201", "120101"],
            address: "的尴尬嘎嘎大发给",
            addressBookId: "",
            cityCode: "1201",
            cityName: "天津",
            districtCode: "120101",
            districtName: "和平",
            endTime: "2025:04:28 20:00",
            linkPhone: "15928585002",
            linkUsername: "卢亮",
            loadType: 1,
            provinceCode: "12",
            provinceName: "天津",
            startTime: "2025-04-28 00:00",
            tags: "",
          },
          {
            location: ["12", "1201", "120102"],
            address: "分公司电饭锅森岛帆高",
            addressBookId: "",
            cityCode: "1201",
            cityName: "天津",
            districtCode: "120102",
            districtName: "河东",
            endTime: "2025:04:28 23:00",
            linkPhone: "15928585003",
            linkUsername: "卢亮一号",
            loadType: 1,
            provinceCode: "12",
            provinceName: "天津",
            startTime: "2025-04-28 13:00",
            tags: "",
          },
          {
            location: ["13", "1302", "130203"],
            address: "分公司大地飞歌森岛帆高送达方刚",
            addressBookId: "",
            cityCode: "1302",
            cityName: "唐山",
            districtCode: "130203",
            districtName: "路北",
            endTime: "2025-04-30 07:00",
            linkPhone: "15928585001",
            linkUsername: "阿鸡",
            loadType: 2,
            provinceCode: "13",
            provinceName: "河北",
            startTime: "2025-04-30 00:00",
            tags: "",
          },
          {
            location: ["13", "1302", "130202"],
            address: "发过的发生讽德诵功森岛帆高水电费刚",
            addressBookId: "",
            cityCode: "1302",
            cityName: "唐山",
            districtCode: "130202",
            districtName: "路南",
            endTime: "2025-04-30 22:00",
            linkPhone: "15928585007",
            linkUsername: "阿吉一号",
            loadType: 2,
            provinceCode: "13",
            provinceName: "河北",
            startTime: "2025-04-30 07:00",
            tags: "",
          },
        ],
        receiptType: 1,
        remark: "发斯蒂芬噶是的法师打发三大发手打发送 ",
        vehicle: {
          vehicleLength: ["1.8", "2.7"],
          vehicleMode: ["面包车", "依维柯"],
          vehicleUseType: "整车",
        },
      },
      rules: {
        ownerName: [
          { required: true, message: "货主姓名不能为空", trigger: "change" },
        ],
        ownerPhone: [
          { required: true, message: "货主手机号不能为空", trigger: "change" },
          { validator: validatePhone, trigger: "change" },
        ],
        "cargo.cargoName": [
          { required: true, message: "货物名称不能为空", trigger: "change" },
        ],
        "cargo.packingWays": [
          { required: true, message: "包装方式不能为空", trigger: "change" },
        ],
        "vehicle.vehicleUseType": [
          { required: true, message: "整拼方式不能为空", trigger: "change" },
        ],
        needInvoice: [
          { required: true, message: "发票要求不能为空", trigger: "change" },
        ],
        receiptType: [
          { required: true, message: "回单要求不能为空", trigger: "change" },
        ],
        location: [
          { required: true, message: "省市区不能为空", trigger: "change" },
        ],
        address: [
          { required: true, message: "详细地址不能为空", trigger: "change" },
        ],
        "cargo.weigh": [
          { required: true, message: "货物重量不能为空", trigger: "change" },
        ],
        linkUsername: [
          { required: true, message: "联系人姓名不能为空", trigger: "change" },
        ],
        linkPhone: [
          { required: true, message: "联系人电话不能为空", trigger: "change" },
        ],
        startTime: [
          { required: true, message: "开始时间不能为空", trigger: "change" },
        ],
        endTime: [
          { required: true, message: "结束时间不能为空", trigger: "change" },
        ],
        "cargo.cargoLength": [
          { required: true, message: "长不能为空", trigger: "change" },
        ],
        "cargo.cargoWidth": [
          { required: true, message: "宽不能为空", trigger: "change" },
        ],
        "cargo.cargoHeight": [
          { required: true, message: "高不能为空", trigger: "change" },
        ],
        "cargo.piece": [
          { required: true, message: "货物类型不能为空", trigger: "change" },
        ],
      },
      loading: false, // loading
    };
  },
  mounted() {},
  methods: {
    getConfig,
    // 增加装卸货地
    add(type, item, index) {
      if (this.form[type].length < 2) {
        this.form[type].push({
          location: [],
          address: "",
          addressBookId: "",
          cityCode: "",
          cityName: "",
          districtCode: "",
          districtName: "",
          endTime: "",
          linkPhone: "",
          linkUsername: "",
          loadType: item.loadType,
          provinceCode: "",
          provinceName: "",
          startTime: "",
          tags: "",
        });
      }
    },
    // 删除装卸货地
    del(type, item, index) {
      this.form[type].splice(index, 1);
    },
    handleChange(e, type, key, dotRef) {
      const nodes = this.$refs[dotRef][0].getCheckedNodes();
      this.form[type][key].provinceName = "";
      this.form[type][key].provinceCode = "";
      this.form[type][key].cityName = "";
      this.form[type][key].cityCode = "";
      this.form[type][key].districtCode = "";
      this.form[type][key].districtName = "";
      nodes[0].pathNodes.forEach((node, index) => {
        if (index === 0) {
          this.form[type][key].provinceCode = node.value;
          this.form[type][key].provinceName = node.label;
        } else if (index === 1) {
          this.form[type][key].cityCode = node.value;
          this.form[type][key].cityName = node.label;
        } else if (index === 2) {
          this.form[type][key].districtCode = node.value;
          this.form[type][key].districtName = node.label;
        }
      });
      // // console.log("tuDot:", this.form);
    },
    init() {
      this.dialogShow = true;
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // // console.log(this.form);
          this.$refs.drawerContainer.loading = true;
          this.form.pointList = this.form.dress.concat(this.form.unload);
          orderFreight(this.form)
            .then((res) => {
              this.$refs.drawerContainer.loading = false;
              if (res.code === 200) {
                this.$message.success("下单成功");
                this.dialogShow = false;
              }
            })
            .catch((e) => {
              this.$refs.drawerContainer.loading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.order-box {
  box-sizing: border-box;
  .right-title {
    padding: 0rem 0 0.1rem;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .custom-form-input {
    .custom-label {
      width: 100%;
      line-height: 0.32rem;
      font-size: 0.14rem;
      color: #57585c;
      display: flex;
      align-items: center;
      .label {
        padding-left: 0.1rem;
      }
    }
    .custom-input-box {
      display: flex;
    }
  }
  .custom-form-label {
    ::v-deep .el-form-item {
      display: flex;
      align-items: center;
      margin-bottom: 0rem;

      .el-form-item__label {
        padding-right: 0.2rem;
      }

      .unit {
        padding-left: 0.06rem;
      }
    }
  }
  .line-box {
    .line-box-list {
      display: flex;
      margin-bottom: 0.2rem;
      ::v-deep .el-form-item {
        margin-bottom: 0.2rem;
      }
      .line-list-left {
        flex: 1;
        background: #f7fbff;
        border-radius: 0.08rem;
        padding: 0.2rem 0.2rem 0rem;
        box-sizing: border-box;
        .line-left-top {
          display: flex;
          align-items: center;
          border-bottom: 0.01rem dashed #dce5f5;
          //padding-bottom: 0.2rem;
          box-sizing: border-box;
          .line-left-top-img-box {
            width: 0.8rem;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            .line-left-top-left {
              width: 0.3rem;
              height: 0.3rem;
              flex-shrink: 0;
              margin-top: -0.2rem;
            }
          }

          .line-left-top-right {
            flex: 1;

            .city-box {
              margin: 0rem 0 0.1rem;
            }
            .address-box {
            }
          }
        }
        .line-left-bottom {
          ::v-deep .el-form-item {
            margin-bottom: 0.1rem;
          }
          .line-left-bottom-list {
            display: flex;
            align-items: center;
            width: 100%;
            margin: 0.1rem 0;
            .left-txt {
              width: 0.8rem;
              text-align: right;
              font-size: 0.14rem;
              line-height: 0.32rem;
              flex-shrink: 0;
            }
            .right-input {
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: space-between;
            }
          }
        }
      }
      .line-list-right {
        flex-shrink: 0;
        width: 1rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-left: 0.06rem;
        box-sizing: border-box;
        .jia-img {
          width: 0.26rem;
          height: 0.26rem;
        }
        .jia-txt {
          font-size: 0.12rem;
          color: #434343;
          padding-top: 0.06rem;
        }
      }
    }
  }
}
</style>
